import { useTranslation } from "react-i18next";
import PagesContainer from "../../components/UI/PagesContainer";
import { useParams } from "react-router-dom";
import { BeneficiaryService } from "../../services/beneficiary.service";
import { useFetch } from "@4uhub/lib4uhub";
import { useCallback, useEffect, useState } from "react";
import { IGracePeriodCpt } from "../../models/grace-period-cpt";
import { Box } from "@mui/material";
import { GracePeriodCptData } from "../../components/GracePeriodCpt/GracePeriodCptData/GracePeriodCptData";
import { usePage } from "../../hooks/usePage";

const beneficiaryService = new BeneficiaryService();

const TRANSLATION_PATH = "page.beneficiaryGracePeriodCpt.";

const BeneficiaryGracePeriodCpt = () => {
  const { t } = useTranslation();

  const { pageTitle } = usePage();

  const { beneficiaryId } = useParams();

  const { sendRequest, loading } = useFetch(
    beneficiaryService.getGracePeriodAndTemporaryPartialCoverage
  );

  const [nonCptGracePeriods, setNonGracePeriods] = useState<IGracePeriodCpt[]>(
    []
  );

  const [cptGracePeriods, setCptGracePeriods] = useState<IGracePeriodCpt[]>([]);

  const fetchGracePeriods = useCallback(
    async (isCpt: boolean) => {
      if (!beneficiaryId) return;

      const { data, success } = await sendRequest({ beneficiaryId, isCpt });
      if (data && success) {
        if (isCpt) {
          setCptGracePeriods(data);
          return;
        }

        setNonGracePeriods(data);
      }
    },
    [beneficiaryId, sendRequest]
  );

  useEffect(() => {
    fetchGracePeriods(false);
    fetchGracePeriods(true);
  }, [fetchGracePeriods]);

  return (
    <PagesContainer
      title={pageTitle || t(TRANSLATION_PATH + "grace_period_cpt")}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <GracePeriodCptData
          label={t(TRANSLATION_PATH + "grace_period")}
          noDataMessage={t(TRANSLATION_PATH + "no_grace_period")}
          data={nonCptGracePeriods}
          loading={loading}
        />
        <GracePeriodCptData
          label="CPT"
          noDataMessage={t(TRANSLATION_PATH + "no_cpt")}
          data={cptGracePeriods}
          loading={loading}
        />
      </Box>
    </PagesContainer>
  );
};

export default BeneficiaryGracePeriodCpt;
